@if (chunk()) {
<div class="fx-row fx-align-start">
  <div>
    <div class="caption-item-avatar">
      @if (imgUrl) {
      <img [src]="imgUrl" alt="{{ 'avatar' | translate }}" />
      } @if (!imgUrl) {
      <span>{{ initials }}</span>
      }
    </div>
  </div>
  <div class="fx-column fx-align-start caption-item-container">
    <label class="caption-item-user">{{ username }}</label>
    <div class="caption-item-chunk">
      <ng-content></ng-content>
    </div>
  </div>
</div>
}
